import { library } from "@fortawesome/fontawesome-svg-core";
import { faRecycle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Entry from "./taxCalInput";

library.add(faRecycle);

class TaxCalScreen extends Component {
  InitialState = {
    time: "12",
    salary: "",
    housing: "",
    leave: "",
    utility: "",
    dressing: "",
    lap: "",
    nhf: "",
    pension: "",
    nhis: "",
    other: "",
    isShowAllowance: false,
    isShowRelief: false,
    isShowBasic: true
  };

  state = {
    time: "12",
    salary: "",
    housing: "",
    leave: "",
    utility: "",
    dressing: "",
    lap: "",
    nhf: "",
    pension: "",
    nhis: "",
    other: "",
    isShowAllowance: false,
    isShowRelief: false,
    isShowBasic: true
  };

  storeSalary = val => {
    this.setState({ salary: val.target.value });
  };
  storeLeave = val => {
    this.setState({ leave: val.target.value });
  };
  storeHousing = val => {
    this.setState({ housing: val.target.value });
  };
  storeUtility = val => {
    this.setState({ utility: val.target.value });
  };
  storePension = val => {
    this.setState({ pension: val.target.value });
  };
  storeDressing = val => {
    this.setState({ dressing: val.target.value });
  };
  storeOther = val => {
    this.setState({ other: val.target.value });
  };
  storeLap = val => {
    this.setState({ lap: val.target.value });
  };
  storeNHF = val => {
    this.setState({ nhf: val.target.value });
  };
  storeNHIS = val => {
    this.setState({ nhis: val.target.value });
  };
  setTime = val => {
    this.setState({ time: val.target.value });
  };

  resetState = () => {
    this.setState(this.InitialState);
  };

  reload = () => {
    this.setState({
      isShowAllowance: false,
      isShowRelief: false,
      isShowBasic: false
    });
    setTimeout(() => {
      this.setState({
        isShowBasic: true
      });
    }, 100);

    // this.props.history.push("/calc");
  };

  //Declare all variables
  con_income = 0;
  gratuity = 0;
  chargeable = 0;
  total_deduction = 0;
  consolidated_relief = 0;
  con_income = 0;
  paye = 0;
  eff_tax = 0;
  tax_inc = 0;
  net_inc = 0;
  ded = 0;
  action = 0;

  calculate = month => {
    let salary = Number(this.state.salary);
    let housing = Number(this.state.housing);
    let leave = Number(this.state.leave);
    let utility = Number(this.state.utility);
    let dressing = Number(this.state.dressing);
    let other = Number(this.state.other);
    let lap = Number(this.state.lap);
    let nhf = Number(this.state.nhf);
    let pension = Number(this.state.pension);
    let nhis = Number(this.state.nhis);

    this.con_income =
      (housing + other + leave + utility + dressing + salary) * month;

    if (this.con_income < 304347.83) {
      this.consolidated_relief = 0;
    } else {
      this.consolidated_relief = 200000 + 0.2 * this.con_income;
    }

    pension = pension * 0.01 * this.con_income;

    nhf = nhf * 0.01 * this.con_income;

    nhis = nhis * 0.01 * this.con_income;

    this.total_deduction =
      this.consolidated_relief + lap + nhf + nhis + pension;

    this.chargeable = this.con_income - this.total_deduction;

    this.net_inc = this.con_income - (lap + nhf + nhis + pension);

    this.ded = lap + nhf + nhis + pension;

    if (this.con_income < 304347.83) {
      this.paye = this.con_income * 0.01;
    } else if (this.chargeable > 0 && this.chargeable <= 300000) {
      this.paye = this.chargeable * 0.07;
    } else if (this.chargeable > 300000 && this.chargeable <= 600000) {
      this.paye = 300000 * 0.07 + (this.chargeable - 300000) * 0.11;
    } else if (this.chargeable > 600000 && this.chargeable <= 1100000) {
      this.paye =
        300000 * 0.07 + 300000 * 0.11 + (this.chargeable - 600000) * 0.15;
    } else if (this.chargeable > 1100000 && this.chargeable <= 1600000) {
      this.paye =
        300000 * 0.07 +
        300000 * 0.11 +
        500000 * 0.15 +
        (this.chargeable - 1100000) * 0.19;
    } else if (this.chargeable > 1600000 && this.chargeable <= 3200000) {
      this.paye =
        300000 * 0.07 +
        300000 * 0.11 +
        500000 * 0.15 +
        500000 * 0.19 +
        (this.chargeable - 1600000) * 0.21;
    } else if (this.chargeable > 3200000) {
      this.paye =
        300000 * 0.07 +
        300000 * 0.11 +
        500000 * 0.15 +
        500000 * 0.19 +
        1600000 * 0.21 +
        (this.chargeable - 3200000) * 0.24;
    } else {
      this.paye = 0;
    }

    // Display Effective Tax
    this.eff_tax = (this.paye / this.con_income) * 100;

    if (this.chargeable < 0) {
      alert(
        // 'Hmmm!',
        "Your Total Income amount cannot be lower than Reliefs"
      );
    } else {
      this.showAnswer();
    }
  };

  numberWithCommas = number => {
    number = number.toFixed(2);
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  //diplay results function
  showAnswer = () => {
    let result = {
      gross_income: this.numberWithCommas(this.con_income),
      deductions: this.numberWithCommas(this.ded),
      net_income: this.numberWithCommas(this.net_inc),
      consolidated_relief: this.numberWithCommas(this.consolidated_relief),
      taxable_income: this.numberWithCommas(this.chargeable),
      tax_due: this.numberWithCommas(this.paye),
      effective_tax_rate: this.numberWithCommas(this.eff_tax),
      gross_income_month: this.numberWithCommas(this.con_income / 12),
      deductions_month: this.numberWithCommas(this.ded / 12),
      net_income_month: this.numberWithCommas(this.net_inc / 12),
      consolidated_relief_month: this.numberWithCommas(
        this.consolidated_relief / 12
      ),
      taxable_income_month: this.numberWithCommas(this.chargeable / 12),
      tax_due_month: this.numberWithCommas(this.paye / 12),
      effective_tax_rate_month: this.numberWithCommas(this.eff_tax)
    };

    localStorage.setItem("MobileBntinCalcAnswer", JSON.stringify(result));
    this.props.history.push("/answer");
    // console.log(this.state)
  };

  openAllowance = () => {
    this.setState({ isShowAllowance: !this.state.isShowAllowance });
  };

  openRelief = () => {
    this.setState({ isShowRelief: !this.state.isShowRelief });
  };

  render() {
    let nairaSign = <div>({"\u20A6"})</div>;

    let allowance = "";
    let relief = "";
    let allowanceIcon = "";
    let reliefIcon = "";
    let basic = "";

    if (this.state.isShowBasic) {
      basic = (
        <Entry
          heading={"Basic Salary"}
          currency={nairaSign}
          value={this.state.salary}
          storeValue={this.storeSalary}
          style={styles.entry}
        />
      );
    } else {
      basic = null;
    }
    if (this.state.isShowAllowance) {
      allowance = (
        <div style={{ flex: 1 }}>
          <Entry
            heading={"Housing"}
            currency={nairaSign}
            value={this.state.housing}
            storeValue={this.storeHousing}
            style={styles.entry}
          />
          <Entry
            heading={"Leave"}
            currency={nairaSign}
            value={this.state.leave}
            storeValue={this.storeLeave}
            style={styles.entry}
          />
          <Entry
            heading={"Utility"}
            currency={nairaSign}
            value={this.state.utility}
            storeValue={this.storeUtility}
            style={styles.entry}
          />
          <Entry
            heading={"Dressing"}
            currency={nairaSign}
            value={this.state.dressing}
            storeValue={this.storeDressing}
            style={styles.entry}
          />
          <Entry
            heading={"Others"}
            currency={nairaSign}
            value={this.state.other}
            storeValue={this.storeOther}
            style={styles.entry}
          />
        </div>
      );
      //   allowanceIcon = <Icon name="minus" size={20} color="white" style={{marginTop:5, width:'30%'}}/>
    } else {
      allowance = null;
      //   allowanceIcon =<Icon name="plus" size={20} color="white" style={{marginTop:5, width:'30%'}}/>
    }

    if (this.state.isShowRelief) {
      relief = (
        <div>
          <Entry
            heading={"Pension(%)"}
            value={this.state.pension}
            storeValue={this.storePension}
            style={styles.entry}
          />
          <Entry
            heading={"NHF(%)"}
            value={this.state.nhf}
            storeValue={this.storeNHF}
            style={styles.entry}
          />
          <Entry
            heading={"NHIS(%)"}
            value={this.state.nhis}
            storeValue={this.storeNHIS}
            style={styles.entry}
          />
          <Entry
            heading={"LAP"}
            currency={nairaSign}
            value={this.state.lap}
            storeValue={this.storeLap}
            style={styles.entry}
          />
        </div>
      );
      //   reliefIcon=<Icon name="minus" size={20} color="white" style={{marginTop:5}}/>
    } else {
      relief = null;
      //   reliefIcon=<Icon name="plus" size={20} color="white" style={{marginTop:5}}/>
    }

    return (
      <div style={styles.container}>
        <div onChange={this.setTime} style={styles.radio}>
          <input type="radio" defaultChecked value="12" name="time" /> Monthly
          <input type="radio" value="1" name="time" /> Annually
        </div>

        <div style={styles.groupView}>
          <p style={styles.groupHeading}>Basic</p>
          {basic}
        </div>

        <div style={styles.groupView}>
          <div style={styles.headingView} onClick={() => this.openAllowance()}>
            <p style={styles.groupHeading}>Add Allowances</p>
            {allowanceIcon}
          </div>
          {allowance}
        </div>

        <div style={styles.groupView}>
          <div style={styles.headingView} onClick={() => this.openRelief()}>
            <p style={styles.groupHeading}> Add Reliefs</p>
            {reliefIcon}
          </div>
          {relief}
        </div>

        {/* </ScrollView> */}
        <div style={styles.bottomButtonsStyle}>
          <button
            style={styles.calc}
            onClick={() => this.calculate(Number(this.state.time))}
          >
            Calculate
          </button>
          <button onClick={this.reload} style={styles.refreshButton}>
            <FontAwesomeIcon icon="recycle" />
          </button>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    flex: 1,
    paddingRight: 10,
    backgroundColor: "white"
  },
  entry: {
    width: "100%"
  },
  bottomButtonsStyle: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%"
  },
  calc: {
    marginTop: 20,
    width: "50%",
    height: "40px",
    backgroundColor: "#8cab49",
    borderColor: "transparent",
    color: "white"
  },
  refreshButton: {
    marginTop: 20,
    width: "10%",
    height: "40px",
    backgroundColor: "#ff1a1a",
    borderColor: "transparent",
    color: "white",
    fontSize: "1.5em"
  },
  groupView: {
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 2,
    borderColor: "#ddd",
    borderBottomWidth: 0,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 2,
    elevation: 2,
    marginLeft: 5,
    marginRight: 15,
    marginTop: 10,
    width: "100%",
    paddingBottom: 3,
    paddingRight: 10
  },
  groupHeading: {
    alignSelf: "center",
    fontSize: 15,
    padding: 3,
    color: "white",
    width: "70%"
  },
  buttonStyle: {
    alignSelf: "center",
    justifyContent: "center"
  },
  headingView: {
    backgroundColor: "#4d94ff",
    marginBottom: 5,
    flexDirection: "row"
  },
  radio: {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
    fontSize: 20,
    backgroundColor: "#eee"
  }
};

export default withRouter(TaxCalScreen);
